import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import CloseIcon from '@mui/icons-material/Close';

import QIconButton from 'components/QIconButton';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface CloseFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const CloseField: FC<CloseFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  fieldActive,
  focusField,
}) => {
  const { classes } = useStyles();
  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      onClick={forceStatic ? null : () => callbacks.cancelEdit?.()}
      className={classNames(classes.iconButtonColumn, forceStatic ? 'nopoint skinny' : 'skinny')}
    >
      {editable && SHOW_ALL &&
      <QIconButton
        aria-label="Set Reviewed State"
        ref={fieldActive ?
          (input) => {
            focusField.current = input; // eslint-disable-line
          } : null}
        disabled={forceStatic}
        autoFocus={fieldActive}
        focusRipple
        IconComponent={CloseIcon}
        IconProps={{
          className: classNames(classes.reviewed, 'cancel'),
          disabled: forceStatic,
        }}
        size="small-target"
        tooltip="Cancel Editing"
        TooltipProps={{ distance: 3 }}
      />}
    </RegListItem>
  );
};

export default CloseField;
